import { render, staticRenderFns } from "./DeactivateAccount.vue?vue&type=template&id=e1bb108a&scoped=true&"
import script from "./DeactivateAccount.vue?vue&type=script&lang=js&"
export * from "./DeactivateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bb108a",
  null
  
)

export default component.exports